module.exports = {"Name":"ชื่อ","Email":"อีเมล","Capacity":"ความจุ","RoomType":"ประเภทห้อง","Subject":"หัวข้อ","autoCheckIn":"เช็คอินอัตโนมัติ","SelectAll":"เลือกทั้งหมด","Yes":"ใช่","No":"ไม่ใช่","Building":"อาคาร","Floor":"ชั้น","Zone":"โซน","Facilities":"อุปกรณ์","FirstName":"ชื่อ","LastName":"นามสกุล","Backend":"สิทธิในการเข้าถึง Backend","Department":"ตำแหน่ง","Description":"รายละเอียด","Category":"ประเภท","Start":"เริ่ม","End":"จบ","NameIOT":"ชื่อ","Room":"ห้อง","Code":"รหัส","stringSearch":"คำค้นหา"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/advanceSearch/TH.json
// module id = 1339
// module chunks = 120